import ClassDetail from "./ClassDetail";

export default ClassDetail;
export { ClassDetail };
